export default __webpack_public_path__ + "static/media/botimg.96b9a779.png";